module.exports = __webpack_public_path__ + "img/cl.e265b962.svg";